// Session flag for the 10-second overnight pop-up.
// Key is date-stamped so it naturally resets each day after midnight.

const PREFIX = "srcOvernightPopupSeen.";

function todayKey(): string {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${PREFIX}${yyyy}-${mm}-${dd}`;
}

function sweepOldKeys() {
  if (typeof window === "undefined") return;
  try {
    const keep = todayKey();
    const store = window.sessionStorage;
    for (let i = store.length - 1; i >= 0; i--) {
      const k = store.key(i);
      if (k && k.startsWith(PREFIX) && k !== keep) store.removeItem(k);
    }
  } catch {
    /* ignore */
  }
}

export function hasSeenPopupToday(): boolean {
  if (typeof window === "undefined") return true;
  try {
    sweepOldKeys();
    return window.sessionStorage.getItem(todayKey()) === "1";
  } catch {
    return false;
  }
}

export function markPopupSeenToday(): void {
  if (typeof window === "undefined") return;
  try {
    sweepOldKeys();
    window.sessionStorage.setItem(todayKey(), "1");
  } catch {
    /* ignore */
  }
}

export function clearPopupFlag(): void {
  if (typeof window === "undefined") return;
  try {
    const store = window.sessionStorage;
    for (let i = store.length - 1; i >= 0; i--) {
      const k = store.key(i);
      if (k && k.startsWith(PREFIX)) store.removeItem(k);
    }
  } catch {
    /* ignore */
  }
}